<template>
  <div class="modify-wrap">
    <Modal v-model="visible" :title="e2c(info.domain)" :hasFooter="false" @on_cancel="closeModal">
      <template slot="body">
        <div class="mod-item flex-wrap clearfix">
          <span class="col-flex-1">账号：</span>
          <div
            :class="[
              'login-box__wrapper',
              'clearfix',
              'col-flex-4',
              account_error ? 'err-focus' : ''
            ]"
          >
            <input
              @focus="getFocus"
              @blur="removeFocus"
              type="text"
              id="account"
              class="login-input login-input_big"
              placeholder="请输入账号"
              v-model="account"
            />
            <span class="hint errright">{{ account_error }}</span>
            <!-- <input class="login-input" placeholder="输入手机号" v-model="tel" /> -->
          </div>
        </div>
        <div class="mod-item flex-wrap clearfix">
          <span class="col-flex-1">密码：</span>
          <div
            :class="[
              'login-box__wrapper',
              'clearfix',
              'col-flex-4',
              password_error ? 'err-focus' : ''
            ]"
          >
            <input
              @focus="getFocus"
              @blur="removeFocus"
              v-model="psw"
              class="login-input"
              placeholder="输入密码"
            />
            <span class="hint errright">{{ password_error }} </span>
          </div>
        </div>
        <div v-if="imgCodeSrc" class="mod-item flex-wrap clearfix">
          <span class="col-flex-1">验证码：</span>
          <div
            :class="['login-box__wrapper', 'col-flex-4', 'clearfix', code_error ? 'err-focus' : '']"
          >
            <input
              @focus="getFocus"
              @blur="removeFocus"
              v-model="code"
              class="login-input login-input_min"
              placeholder="输入验证码"
            />
            <span class="hint errright">{{ code_error }} </span>
          </div>
        </div>
        <div style="text-align: center;" v-show="imgCodeSrc" class="login-btn__wrapper clearfix">
          <ImgCode :src="imgCodeSrc" @get_new_img="getImageCode"></ImgCode>
        </div>
        <div
          v-if="needPhone"
          :class="['login-box__wrapper', 'clearfix', code_error ? 'err-focus' : '']"
        >
          <input
            v-model="codePhone"
            @focus="getFocus"
            @blur="removeFocus"
            type="text"
            class="login-input login-input_big login-input_left login-input_psw fl"
            placeholder="验证码"
          />
          <span class="hint errcenter">{{ sms_code_error }} </span>
          <countBtn
            @result="resultHandler"
            :usage="resUse"
            class="modal-count"
            :value="account"
            :clean="clean"
            :address="address"
          ></countBtn>
        </div>
        <div style="text-align: center;" class="login-btn__wrapper clearfix" v-if="request_error">
          <span class="error-info">获取验证码失败，请稍后再试</span>
        </div>
        <div class="login-btn__wrapper clearfix">
          <a-button
            :disabled="!validSub"
            :class="['login-btn', 'login-btn_big', validSub ? 'active-login' : 'disable']"
            @click="save"
            :loading="loading"
          >
            保存
          </a-button>
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import { msgTip } from '@/utils/urlUtils'
import { api_post } from '@/utils/http.ts'
import ImgCode from '@/components/enroll/ImgCode.vue'
import Modal from './Modal.vue'
import partyMixin from '@/apps/party/mixin.js'
import CountBtn from './CountBtn.vue'

export default {
  name: 'ModifyThirdPartyModal',
  // mixins: [partyMixin],
  data() {
    return {
      request_error: '',
      imgCodeSrc: '',
      password_error: '',
      account_error: '',
      code_error: '',
      sms_code_error: '',
      account: this.info.account,
      //验证码
      code: '',
      //密码
      psw: '',
      codePhone: '', // 手机验证码
      visible: this.value,
      tel: '',
      clean: '',
      imgCodeIndeed: false,
      address: '/search/api/auth/send-sms-code-3rd',
      loading: false,
      needPhone: false
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default: null
    }
  },
  watch: {
    value: function(val) {
      this.visible = val
      // console.log(this.info.domain)
      switch (this.info.domain) {
        case 'jyeoo':
          if (val) {
            this.account = this.info.account
            this.getImageCode()
          } else {
            this.reset()
          }
          break
        case 'zxxk':
          if (val) {
            this.account = this.info.account
          } else {
            this.reset()
          }
          break
        default:
          this.reset()
          break
      }
    }
  },
  model: {
    prop: 'value',
    event: 'on_cancel'
  },
  computed: {
    validSub() {
      switch (this.info.domain) {
        case 'jeyoo':
          return this.account && this.code && this.psw
        case 'zxxk':
          if (this.needPhone) {
            return this.account && this.psw && this.code && this.codePhone
          } else {
            return this.account && this.psw
          }
        default:
          return false
      }
    },
    resUse() {
      return {
        usage: '3rd-bind',
        phone: this.account,
        domain: 'zxxk',
        captcha: this.code
      }
    }
  },
  mounted() {},
  methods: {
    e2c(type) {
      let item = '菁优网'
      switch (type) {
        case 'jyeoo':
          item = '菁优网'
          break
        case 'zxxk':
          item = '学科网'
          break
        case 'zujuan':
          item = '21世纪组卷'
          break
        case 'wenku':
          item = '文库'
          break
      }
      return item
    },
    reset() {
      this.code = ''
      this.psw = ''
      this.password_error = ''
      this.code_error = ''
      this.imgCodeSrc = ''
      this.sms_code_error = ''
    },
    closeModal: function() {
      this.visible = false
      this.$emit('on_cancel')
    },
    async save() {
      this.loading = true
      let rdata = await api_post('/search/api/auth/account/modify', {
        domain: this.info.domain,
        account_id: this.info.account_id,
        account: this.account,
        password: this.psw,
        captcha: this.code,
        verifyCode: this.codePhone || ''
      })
      this.loading = false
      if (rdata.success) {
        this.closeModal()
        msgTip({ type: 'success', msg: '修改成功' })
        this.$emit('on_modified', rdata.data)
      } else {
        this.password_error = rdata.password_error || ''
        this.account_error = rdata.account_error || ''
        this.code_error = rdata.code_error || ''
        if (this.code_error) {
          this.imgCodeSrc = rdata.data.captcha_image_src + '?s=' + Math.random()
        }
        switch (rdata.code) {
          case 5:
            this.imgCodeSrc = rdata.data.captcha_image_src + '?s=' + Math.random()
            this.sms_code_error = rdata.sms_code_error || ''
            this.needPhone = true
            break
          default:
            break
        }
      }
    },
    async getImageCode() {
      let request = {
        domain: this.info.domain,
        account: this.account
      }
      if (this.info.domain === 'zxxk') {
        request = { ...request, ...{ password: this.psw } }
      }
      let rdata = await api_post('/search/api/auth/account/modify', request)
      if (rdata.success) {
        this.imgCodeSrc = rdata.data.captcha_image_src + '?s=' + Math.random()
      } else {
        this.account_error = rdata.account_error || ''
        this.request_error = rdata.request_error || ''
        if (rdata.data.captcha_image_src) {
          this.imgCodeSrc = rdata.data.captcha_image_src + '?s=' + Math.random()
        }
        switch (rdata.code) {
          case 5:
            //  this.imgCodeSrc = rdata.data.captcha_image_src + '?s=' + Math.random()
            break
          default:
            break
        }
      }
    },
    removeFocus(e) {
      let id = e.target.id
      let targetParent = e.target.parentElement
      if (targetParent) {
        let classes = targetParent.classList
        classes.remove('nor-focus')
        if (id == 'account') {
          this.getImageCode()
        }
      }
    },
    getFocus(e) {
      let targetParent = e.target.parentElement
      if (targetParent) {
        targetParent.classList.add('nor-focus')
      }
    },
    resultHandler(msg) {
      if (msg) {
        this.code_error = msg
      } else {
        this.code_error = ''
      }
    }
  },
  components: { Modal, ImgCode, CountBtn }
}
</script>
<style lang="scss">
.modify-wrap {
  .error-info {
    text-align: center;
    color: rgba(0, 0, 0, 0.65);
  }
  .mod-item > span {
    height: 37px;
    width: 37px;
    display: inline-block;
  }
  .mod-item {
    &:before,
    &:after {
      content: '';
      display: table;
      clear: both;
    }
  }
}
</style>
